// extracted by mini-css-extract-plugin
module.exports = {"form":"userSummary_form__NK5qm","tags":"userSummary_tags__1Ks3t"};